import { FC } from 'react';

import { Icon } from '@purpur/library/icon';
import { filter } from '@purpur/library/icon/assets/filter';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { SearchFacet, SearchFilters, SearchFilterValue } from '../../model';
import { SEARCH_TEST_ID } from '../../test/test-ids';
import { FacetsDrawer } from '../FacetsDrawer/FacetsDrawer';
import { Facets } from './Facets';
import { DrawerOpenButton, DrawerOpenButtonName } from './Facets.styles';

type Props = {
    facets: SearchFacet[];
    filters: SearchFilters;
    onChange: (fieldName: string, filter: SearchFilterValue) => void;
    onRemoveAllFilters: () => void;
    className?: string;
};

export const ProductsFacetsDrawer: FC<Props> = ({ facets, filters, onChange, onRemoveAllFilters, className }) => {
    const { t } = useTranslations();

    return (
        <FacetsDrawer
            id="search-facets-drawer"
            triggerButton={(onClick, isOpen) => (
                <DrawerOpenButton
                    onClick={onClick}
                    aria-expanded={!!isOpen}
                    aria-controls="search-facets-drawer"
                    data-test={SEARCH_TEST_ID.FACETS_DRAWER_OPEN_BUTTON}
                >
                    <DrawerOpenButtonName>{t['search.component.facets_drawer.open_button']}</DrawerOpenButtonName>
                    <Icon svg={filter} size="md" />
                </DrawerOpenButton>
            )}
            onClear={onRemoveAllFilters}
            dataTest={SEARCH_TEST_ID.RESULTS_PRODUCTS_FACETS_DRAWER}
            className={className}
        >
            <Facets facets={facets} filters={filters} showCount={true} onChange={onChange} />
        </FacetsDrawer>
    );
};
